import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ILookup } from '../interfaces/ILookup.interface';
import { Observable, BehaviorSubject } from 'rxjs';
import { ChangeSet } from '../models/ChangeSet.model';
import { UrlPrefix } from "../constants/url-prefix.constants";

@Injectable()
export class ChangeSetService {
    constructor(private http: HttpClient) { }
    public changeSetModified = new BehaviorSubject<boolean>(null);

    public getChangeSetLookups(): Observable<Array<ILookup<number, string>>> {
        return this.http.get<Array<ILookup<number, string>>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/changeSets/lookups`);
    }

    public getChangeSetFilterLookups(): Observable<Array<ILookup>> {
        return this.http.get<Array<ILookup>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/changeSets/filterLookups`);
    }

    public save(changeSet: ChangeSet): Observable<number> {
        return this.http.post<number>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/changeSets`, JSON.stringify(changeSet));
    }

    public selectChangeSet(id: number): Observable<void> {
        return this.http.post<void>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/changeSets/${id}/selected`, {});
    }

    public getSelectedChangeSet(): Observable<ILookup<number, string>> {
        return this.http.get<ILookup<number, string>>(`${UrlPrefix.OLD_SETUP_API_PREFIX}/changeSets/selected`);
    }
}
